angular.module('zc.zenclerkS')

  .component('zcsProjectsInInstallation', {
    templateUrl: '/templates/zenclerk_s/directives/projects_in_installation/projects_in_installation.html',
    bindings: {
      projects: '<'
    },
    controller: zcsProjectsInInstallationController
  });

zcsProjectsInInstallationController.$inject = ['$q', 'AgencyProject'];
function zcsProjectsInInstallationController($q, AgencyProject) {
  let vm = this;
  vm.statuses = AgencyProject.projectStatuses;
  vm.projectsWithoutCampaign = undefined;

  vm.$onChanges = changes => {

    // if there are no projects (first onChanges call), don't show anything
    if(!vm.projects || vm.projects.length === 0) {
      return;
    }

    vm.projectsWithoutCampaign = _.filter(vm.projects, p => p.status < 6).length;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/projects_in_installation/projects_in_installation.component.js